var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame55(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 66,
    viewBox: "0 0 54 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9965 25.9152V25.9153C51.9965 30.0356 48.44 33.4271 43.996 33.4271C39.5521 33.4271 35.9956 30.0352 35.9956 25.9153H35.4956H34.9956C34.9956 30.0359 31.4431 33.4271 26.9995 33.4271C22.5529 33.4271 18.9965 30.0351 18.9965 25.9153H18.4965H17.9965C17.9965 30.036 14.4465 33.4271 10.0005 33.4271C5.55228 33.4271 2.00001 30.0354 2.00001 25.9153L2 22.9675H51.9969L51.9965 25.9152Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2999 2.75H44.4014L51.7418 19.8824H37.4746L35.2999 2.75Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25818 19.8838L9.5986 2.75098H18.7001L16.5257 19.8838H2.25818Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5978 19.8838L22.7729 2.75098H31.2229L33.3985 19.8838H20.5978Z",
    fill: "white",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18359 35.5022C5.12301 36.7953 7.47375 37.5547 10.0016 37.5547C13.3134 37.5547 16.3201 36.2523 18.4978 34.1492C20.68 36.2545 23.6888 37.5547 27.0006 37.5547C30.3121 37.5547 33.319 36.2548 35.4969 34.1495C37.6788 36.2546 40.6857 37.5547 43.9994 37.5547C46.5263 37.5547 48.8756 36.7948 50.8174 35.5013L50.8169 63.2499H45.9662V51.2439C45.9662 48.0977 43.485 45.5249 40.3933 45.5249C37.3021 45.5249 34.8204 48.0997 34.8204 51.2439V63.2499H3.18359V35.5022ZM30.1681 55.3888H30.6681V54.8888V42.2265V41.7265H30.1681H8.53652H8.03652V42.2265V54.8888V55.3888H8.53652H30.1681Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame55);
export default __webpack_public_path__ + "static/media/Frame 55.1455f40ffef330486f0f0e835fd8feb5.svg";
export { ForwardRef as ReactComponent };